import { render } from "./CalendarDetail.vue?vue&type=template&id=b92449e2&scoped=true"
import script from "./CalendarDetail.vue?vue&type=script&lang=js"
export * from "./CalendarDetail.vue?vue&type=script&lang=js"

import "./CalendarDetail.vue?vue&type=style&index=0&id=b92449e2&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b92449e2"]])

export default __exports__